import React, { useEffect, useState } from "react";
import Link from "next/link";

import getStrainLists from "@/api/requests/getStrainLists";
import { Strain } from "@/custom-types/Strain";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";

import StrainCard, {
  StrainCardPlaceholder,
} from "@/components/botanic/StrainCard";
import TrackImpression from "@/components/TrackImpression";

const PopularStrainsSection = () => {
  const [strains, setStrains] = useState<Strain[] | Record<string, never>[]>([
    {},
    {},
    {},
  ]);
  const coordinates = useSelector(getCoordinates);

  useEffect(() => {
    const getStrains = async () => {
      const response = await getStrainLists({}, 0, 3, coordinates);
      setStrains(response.strains);
    };

    getStrains();
  }, []);

  return (
    <TrackImpression category="Strain Card" label="info" className="my-xxl">
      <h2 className="text-md mb-md">Popular weed strains near you</h2>
      <div className="row">
        {strains?.length ? (
          strains.map((strain, i) =>
            Object.entries(strain).length === 0 ? (
              <div className="col md:col-1/3 mb-md md:mb-none" key={i}>
                <StrainCardPlaceholder
                  orientation="horizontal"
                  className="h-full shadow-low rounded"
                />
              </div>
            ) : (
              <div className="col md:col-1/3 mb-md md:mb-none" key={strain.id}>
                <StrainCard
                  strain={strain as Strain}
                  trackingLabel="info"
                  orientation="horizontal"
                  preserveHeight={true}
                  disableLazyLoad={true}
                />
              </div>
            ),
          )
        ) : (
          <div className="col">An error occurred while fetching strains.</div>
        )}
      </div>
      <div className="mt-md md:mt-xl">
        <Link href="/strains" className="underline text-green">
          see all strains
        </Link>
      </div>
    </TrackImpression>
  );
};

export default PopularStrainsSection;
